import { api } from './api';

export type SearchHitKind = 'lead' | 'campaign' | 'client';

export interface SearchHit {
  kind: SearchHitKind;
  id: number;
  title: string;
  subtitle?: string;
  link: string;
}

interface SearchResponse {
  hits: SearchHit[];
}

export const searchService = {
  async global(q: string): Promise<SearchHit[]> {
    if (q.trim().length < 2) {
      return [];
    }
    const { data } = await api.get<SearchResponse>('/search', { params: { q } });
    return data.hits ?? [];
  },
};
